import React, { useState } from 'react'

import { F0TimelineRow } from '@factorialco/f0-react'
import type { F0TimelineRowTaskProps } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import type { ApprovalsV2ApprovalTimelineEntry } from './workflowApprovalTypes'
import { mapTimelineStatus } from './workflowApprovalHelpers'

interface MultiTaskGroupProps {
  entries: ApprovalsV2ApprovalTimelineEntry[]
  buildEntryItem: (
    entry: ApprovalsV2ApprovalTimelineEntry,
    idx: number,
    isLast: boolean
  ) => F0TimelineRowTaskProps
  alert?: React.ReactNode
  isLast: boolean
}

const MultiTaskGroup = ({ entries, buildEntryItem, alert, isLast }: MultiTaskGroupProps) => {
  const hasCurrent = entries.some((e) => e.status === 'running' || e.status === 'changesrequested')
  const allCompleted = entries.every((e) => e.status === 'completed')
  const [expanded, setExpanded] = useState(!allCompleted)

  const groupStatus = mapTimelineStatus(
    allCompleted ? 'completed' : hasCurrent ? 'running' : 'future'
  )

  const items = entries.map((entry, idx) => buildEntryItem(entry, idx, idx === entries.length - 1))

  return (
    <>
      <F0TimelineRow
        status={groupStatus}
        title={i18n.t('approvals_v2.timeline.tasks_count', { count: '' }).trim()}
        taskCount={entries.length}
        completedCount={entries.filter((e) => e.status === 'completed').length}
        expanded={expanded}
        onExpandToggle={() => setExpanded((prev) => !prev)}
        items={items}
        isLast={isLast}
      />
      {alert}
    </>
  )
}

export default MultiTaskGroup
